import { render, staticRenderFns } from "./channelIndex.vue?vue&type=template&id=42c381e6&scoped=true"
import script from "./channelIndex.vue?vue&type=script&lang=js"
export * from "./channelIndex.vue?vue&type=script&lang=js"
import style0 from "./channelIndex.vue?vue&type=style&index=0&id=42c381e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c381e6",
  null
  
)

export default component.exports